export const CACHE_TTL_MS = Object.freeze({
  NO_CACHE: 0,

  TTL_5_MINUTES: 5 * 60 * 1000,
  TTL_15_MINUTES: 15 * 60 * 1000,
  TTL_30_MINUTES: 30 * 60 * 1000,

  TTL_1_HOUR: 60 * 60 * 1000,
  TTL_3_HOURS: 3 * 60 * 60 * 1000,
  TTL_6_HOURS: 6 * 60 * 60 * 1000,
  TTL_12_HOURS: 12 * 60 * 60 * 1000,
  TTL_24_HOURS: 24 * 60 * 60 * 1000,
});